import { cn } from "../lib/utils"

interface LoadingSpinnerProps {
  text?: string
  size?: "sm" | "md" | "lg"
  className?: string
  fullPage?: boolean
}

const sizeClasses = {
  sm: "h-5 w-5 border-2",
  md: "h-8 w-8 border-4",
  lg: "h-12 w-12 border-4",
}

export function LoadingSpinner({
  text,
  size = "md",
  className,
  fullPage = true,
}: LoadingSpinnerProps) {
  const spinner = (
    <div className={cn("text-center", className)}>
      <div
        className={cn(
          "mb-4 inline-block animate-spin rounded-full border-neutral-200 border-t-primary-600",
          sizeClasses[size]
        )}
      />
      {text && <p className="text-neutral-600">{text}</p>}
    </div>
  )

  if (fullPage) {
    return (
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center py-12">
          {spinner}
        </div>
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center py-12">
      {spinner}
    </div>
  )
}
